import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { RestService } from 'src/app/services/rest-service';
import { AppSettings } from 'src/app/shared/app-settings';
import { GridOptions } from 'ag-grid-community';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EditDeleteRendererComponent } from '../../components/edit-delete-renderer/edit-delete-renderer.component';
import { ConfirmationDialogueComponent } from '../../components/confirmation-dialogue/confirmation-dialogue.component';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css']
,
  standalone: false
})
export class RolesComponent implements OnInit {
  privilegesList: any = [];
  rolesList: any = [];
  gridOptions: GridOptions;
  columnDefs: any;
  rowData: any;
  defaultColDef: any;
  domLayout = '';
  roleName: any = '';
  modalRef: NgbModalRef;
  action = '';
  roleId: any;
  savedPrivileges = [];
  newArray = [];
  popupHeading;
  @ViewChild('addRole', { static: false }) adrole: ElementRef<any>;
  currentUser: any = null;
  constructor(
    private titleService: Title,
    public spinner: SpinnerService,
    private toastr: ToastrService,
    public restService: RestService,
    private ngbModalService: NgbModal,
    private modalService: NgbModal
  ) {
    this.titleService.setTitle("Roles");
    this.domLayout = "autoHeight";
    this.currentUser = localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : null;
  }

  ngOnInit(): void {
    this.getRoles();
    this.getPrivileges();
    let title = this.titleService.getTitle();
  }


  onGridReady(params) {
    params.api.sizeColumnsToFit();
  }

  getPrivileges() {
    this.restService.getRequest(AppSettings.GETPRIVILEGE).subscribe({
      next: (response) => {
        const pList = Array.isArray(response?.data) ? response.data : [];
        pList.forEach(privilege => {
          this.privilegesList.push({
            id: privilege.id,
            name: privilege.name,
            checked: false
          });
        });
      },
      error: (err) => {
        if (err.error?.message?.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error('Session Expired Please login again.', 'Error');
        }
      }
    });
  }

  getRoles() {
    this.spinner.activate();
    this.rolesList = [];
    this.restService.getRequest(AppSettings.GETROLES).subscribe({
      next: (response) => {
        const rList = Array.isArray(response?.data) ? response.data : [];
        rList.forEach(roles => {
          this.rolesList.push({
            id: roles.id,
            name: roles.name,
            privileges: roles.priviliges
          });
        });
        this.gridOptions = {
          defaultColDef: {
            resizable: true,
            sortable: true,
            filter: true,
            headerClass: 'headerClass'
          },
          columnDefs: [
            { headerName: 'Roles Name', field: 'name' },
            { headerName: 'Privileges', field: 'privileges' },
            {
              headerName: 'Action', field: 'action', cellRenderer: EditDeleteRendererComponent,
              cellRendererParams: {
                onEditClick: this.onEditClick.bind(this),
                onDeleteClick: this.onDeleteClick.bind(this),
              }
            }
          ],
          rowData: this.rolesList
        };
      },
      error: (err) => {
        if (err.error?.message?.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error('Session Expired Please login again.', 'Error');
        }
      },
      complete: () => this.spinner.deactivate()
    });
  }

  onAddClick() {
    this.action = 'add';
    this.popupHeading = 'Add Role';
    this.roleName = '';
    this.privilegesList.forEach(element => {
      element.checked = false;
    });
    this.modalRef = this.ngbModalService.open(this.adrole);
  }

  onEditClick(id) {
    this.roleName = '';
    this.popupHeading = 'Edit Role';
    this.privilegesList.forEach(element => {
      element.checked = false;
    });
    this.action = 'edit';
    var item = this.rolesList.find(item => item.id === id);
    this.roleName = item.name;
    this.roleId = item.id;
    this.savedPrivileges = item.privileges;
    this.privilegesList.forEach(element => {
      this.savedPrivileges.forEach(e => {
        if (e == element.name) {
          element.checked = true;
        }
      })
    });
    this.modalRef = this.ngbModalService.open(this.adrole);
  }

  saveRole() {
    if (this.roleName.length > 0 && this.roleName.length < 51) {
      if (this.action == 'add') {
        let selectedPrivs = this.privilegesList.filter(opt => opt.checked).map(opt => opt.id);
        let model = {
          name: this.roleName,
          privileges: selectedPrivs
        }
        if (selectedPrivs.length === 0) {
          this.toastr.error('Please select atleast one privilege', 'Error');
          return;
        }
        this.spinner.activate();
        this.restService.postRequest(AppSettings.ADDROLE, model).subscribe((response) => {
          if (response.success) {
            this.roleName = '';
            this.modalService.dismissAll();
            this.toastr.success('Role added successfully', 'Success');
            this.getRoles();
          }
          this.spinner.deactivate();
        }, (err) => {
          this.spinner.deactivate();
          if (err.error.message.length > 0) {
            this.toastr.error(err.error.message, 'Error');
          } else {
            this.toastr.error('Session Expired Please login again.', 'Error');
          }

        })
      }
      if (this.action == 'edit') {
        let selectedPrivs = this.privilegesList.filter(opt => opt.checked).map(opt => opt.id);
        let model = {
          id: this.roleId,
          name: this.roleName,
          privileges: selectedPrivs
        }
        if (selectedPrivs.length === 0) {
          this.toastr.error('Please select atleast one privilege', 'Error');
          return;
        }
        this.spinner.activate();
        this.restService.putRequest(AppSettings.EDITROLE, model).subscribe((response: any) => {
          if (response.success) {
            this.roleName = '';
            this.modalService.dismissAll();
            // this.adprivilege.nativeElement.click();
            this.toastr.success('Role updated successfully', 'Success');
            this.getRoles();            
          }
          this.spinner.deactivate();
        }, (err) => {
          this.spinner.deactivate();
          if (err.error.message.length > 0) {
            this.toastr.error(err.error.message, 'Error');
          } else {
            this.toastr.error('Session Expired Please login again.', 'Error');
          }
        })
      }
    }
    else {
      // this.toastr.error('Role name should not be more than 50 characters.', 'Error');
    }
  }

  onDeleteClick(id) {
    let popupData = {
      title: "Delete Confirmation",
      message: "Are you sure you want to delete this item?",
      cancelBtnText: "No",
      confirmBtnText: "Confirm"
    }
    let dialoge = this.ngbModalService.open(ConfirmationDialogueComponent);
    dialoge.componentInstance._data = popupData;
    dialoge.result.then(data => {
      if (data) {
        this.spinner.activate();
        this.restService.deleteRole(AppSettings.DELETEROLE, id).subscribe((response: any) => {
          if (response.status == 200) {
            this.toastr.success('Role deleted successfully', 'Success');
            this.getRoles();
            this.spinner.deactivate();
          }
        }, (err) => {
          this.spinner.deactivate();
          if (err.error.message.length > 0) {
            this.toastr.error(err.error.message, 'Error');
          } else {
            this.toastr.error('Session Expired Please login again.', 'Error');
          }
        })
      }

    });

  }
}
